export default function initializeTabs() {
        const tabs = document.querySelectorAll('.item_tab');
        const containers = document.querySelectorAll('.block-tabs-content');
        console.log('DOMContentLoaded');
        tabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                const targetId = this.getAttribute('data-target');
                const targetContainer = document.getElementById(targetId);

                if (targetContainer) {
                    containers.forEach(function(container) {
                        container.classList.remove('active');
                    });
                    tabs.forEach(function(tab) {
                        tab.classList.remove('active');
                    });

                    targetContainer.classList.add('active');
                    this.classList.add('active');
                }
            });
        });
}

